import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const WebsiteSlug = ({ slug, published, copyCta, longSlugName, copyLinkDisabled, isClipboardSupported }) => (
  <div
    className={classNames(
      'website-slug__container',
      'manage-section',
      { 'website-long-slug__container': longSlugName }
    )}
  >
    <span className="title">your website url</span>
    <span className="website-slug__url">
      <i
        className={classNames(
          'zolaicon',
          { 'zolaicon-visible': published },
          { 'zolaicon-closed-eye': !published }
        )}
      />{`${window.location.host}/wedding/`}<span className="website-slug__name">{slug}</span>
      {
        published && isClipboardSupported ?
          <span
            id="website-slug__copy-text"
            className={classNames(
              'website-slug__copy text-button',
              { disabled: copyLinkDisabled }
            )}
            data-clipboard-text={`${window.location.host}/wedding/${slug}`}
          >
            {copyCta}
          </span> :
          <a href="/account/settings/urls"><span className="website-slug__edit text-button hidden-xs">edit</span></a>
      }
      {
        !published &&
        <a href="/account/settings/urls"><i className="zolaicon zolaicon-pencil short-slug__pencil" /></a>
      }
    </span>
    {
      !published &&
      <a href="/account/settings/urls"><i className="zolaicon zolaicon-pencil long-slug__pencil" /></a>
    }

  </div>
);

WebsiteSlug.propTypes = {
  slug: PropTypes.string,
  published: PropTypes.bool,
  longSlugName: PropTypes.bool,
  copyCta: PropTypes.string,
  copyLinkDisabled: PropTypes.bool,
  isClipboardSupported: PropTypes.bool
};

export default WebsiteSlug;



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/WebsiteSlug.jsx
 **/